export const tenant = "uk";
export const environment = "production";
